import * as yup from "yup";

import * as RHFUserValidationRules from "@/utils/validation/schemas/user.RHF";

export const RegisterFormValidationSchema = yup.object({
    firstName: RHFUserValidationRules.firstName,
    lastName: RHFUserValidationRules.lastName,
    email: RHFUserValidationRules.checkExistingEmail,
    password: RHFUserValidationRules.password
});

export type RegisterFormValues = yup.InferType<
    typeof RegisterFormValidationSchema
>;
